import React, { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import Success from "utils/Notifications/Success";
import Error from "utils/Notifications/Error";
import { useAppSelector } from "hooks/redux";
import { RootState } from "store/store";

export interface UnreadData {
    robot_id: string;
    changes_unread: number;
    system_unread: number;
    web_alerts_unread: number;
    total_unread: number;
}
const WsRobotsUnreadHandler: React.FC = () => {
    const wsRef = useRef<WebSocket | null>(null);
const { loggedIn } = useAppSelector((state: RootState) => state.auth);
    useEffect(() => {
        if (!loggedIn) return;
        const connect = () => {
            const token = Cookies.get("access");
            if (!token) {
                console.warn("[robots_unread] Токен отсутствует");
                return;
            }

            const wsUrl = `${process.env.REACT_APP_SOCKET_SECURE}${process.env.REACT_APP_BASE_API_DOMAIN}/wss/robots_unread/?token=${encodeURIComponent(token)}`;

            const socket = new WebSocket(wsUrl);
            wsRef.current = socket;

            socket.onopen = () => {
                Success("[robots_unread] Соединение установлено");
            };

            socket.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);

                    if (
                        data.type === "robot_unread" &&
                        Array.isArray(data.items)
                    ) {
                        const event = new CustomEvent("robots_unread_update", {
                            detail: data.items,
                        });
                        window.dispatchEvent(event);
                    }
                } catch (err) {
                    console.error("[robots_unread] Ошибка парсинга:", err);
                    Error(`[robots_unread] Ошибка парсинга: ${err}`);
                }
            };

            socket.onerror = (error) => {
                console.error("[robots_unread] Ошибка соединения:", error);
                Error("[robots_unread] Ошибка соединения");
            };

            socket.onclose = (event) => {
                console.log(
                    "[robots_unread] Соединение закрыто",
                    event.code,
                    event.reason,
                );

                setTimeout(() => {
                    if (document.hasFocus()) {
                        connect();
                    }
                }, 5000);
            };
        };

        connect();

        return () => {
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                wsRef.current.close();
                console.log("[robots_unread] Соединение закрыто при unmount");
            }
        };
    }, [loggedIn]);

    return null;
};

export default WsRobotsUnreadHandler;
